import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPage } from '@/features/privacy/pages/privacy-page';

export const Route = createFileRoute('/_app/privacy')({ component: PrivacyPage });
